import React, { createContext, useContext, useState, useEffect } from "react";
import { useGlobalContext } from "./GlobalContext";
import Cookies from "js-cookie";

export const PayrollContext = createContext();

export const PayrollContextComponent = ({ children }) => {
  // payrollReimbrusment code
  const { baseUrl, openToast } = useGlobalContext();
  // state to store the staffs
  const [staffs, setStaffs] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isOffCanvasOpenAction, setIsOffCanvasOpenAction] = useState(false);
  const [activeReimbursementStaff, setActiveReimbursementStaff] =
    useState(null);
  const [reimbursementData, setReimbursementData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [loadingStaff, setLoadingStaff] = useState(false)
  const [payrollDetail, setPayrollDetail] = useState([]);
  console.log(payrollDetail)
  // state to handle the delete button in edit and Add mode
  const currentMonthYear = new Date().toISOString().slice(0, 7);
  const [loading, setLoading] = useState(false);
  const [selectAllInput, setSelectAllInput] = useState([]);
  const [monthYear, setMonthYear] = useState(currentMonthYear);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [defaultMonth, setDefaultMonth] = useState("");

  //  fetch the payroll table staff list
  const fetchStaffs = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      setStaffs([]);
      return;
    }
    const [year, month] = monthYear.split("-");
    setLoadingStaff(true)
    try {
      const response = await fetch(
        `${baseUrl}payroll/allstaff/${month}/${year}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      const result = await response.json();
      setStaffs(result);
    } catch (err) {
      console.log(err.message);
    }
    finally {
      setLoadingStaff(false);
    }
  };

  useEffect(() => {
    fetchStaffs();
  }, [monthYear]);


  // toggle the total reimbursement Modal
  const toggleTotalReimbrusmentModal = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };

  //   edit functionality for the rebrusement
  const handleEditReimbursement = (reimbursement) => {
    console.log(isOffCanvasOpen);
    setEditMode(true);
    setReimbursementData(reimbursement);
    setIsOffCanvasOpenAction(true);
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };
  // function to delete the ReimBrusment


  // payrollReimbrusment code


  const calculateDailySalary = (monthlySalary, workingDaysInMonth = 30) => {
    if (monthlySalary && monthlySalary > 0) {
      return (monthlySalary / workingDaysInMonth).toFixed(2); // Divide by the number of working days in a month
    } else {
      return 0; // Return 0 if monthlySalary is invalid
    }
  };

  function calculateTotalFineAndOvertime(punchRecords) {
    let totalFine = 0;
    let totalOvertime = 0;

    punchRecords.forEach((record) => {
      if (record.fine) {
        console.log("record.fine", record.fine);
        totalFine += record.fine.totalAmount || 0;
      }
      if (record.Overtime) {
        totalOvertime += record.Overtime.totalAmount || 0;
      }
    });

    return { totalFine, totalOvertime };
  }


  async function fetchPayrollDetails() {
    if (!Cookies.get("flowChangerAuthToken")) {
      setPayrollDetail
      ([]);
      return;
    }
    try {
      setLoading(true);
      const response = await fetch(
        `${baseUrl}payroll/allstaff/${month}/${year}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      if (response.status == 200) {
        const data = await response.json();
        console.log(data)
        setPayrollDetail(data);
      } else {
        openToast("An Error Occured", "Error");
      }
    } catch (error) {
      openToast("An Error Occured", "Error");
    } finally {
      setLoading(false);
    }
  }

  const handleMonthChange = (e) => {
    const value = e.target.value; // This gives the value in "YYYY-MM" format
    const [yearValue, monthValue] = value.split("-"); // Split the value into year and month
    setYear(yearValue);
    setMonth(monthValue);
  };




  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = String(now.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    setDefaultMonth(`${currentYear}-${currentMonth}`);
    setYear(currentYear);
    setMonth(currentMonth);
  }, []);

  useEffect(() => {
    if (month === "" || year === "") {
      return;
    }
    fetchPayrollDetails();
  }, [month, year]);

  return (
    <PayrollContext.Provider
      value={{
        fetchStaffs,
        monthYear,
        setMonthYear,
        staffs,
        handleEditReimbursement,
        activeReimbursementStaff,
        setActiveReimbursementStaff,
        reimbursementData,
        selectAllInput,
        setSelectAllInput,
        calculateDailySalary,
        calculateTotalFineAndOvertime,
        isLoading,
        setIsLoading,
        loadingStaff,
        setIsOffCanvasOpenAction,
        isOffCanvasOpenAction,
        editMode,
        setEditMode,
        isOffCanvasOpen,
        setIsOffCanvasOpen,
        toggleTotalReimbrusmentModal,
        fetchPayrollDetails,
        handleMonthChange,
        year,
        month,
        payrollDetail,
        loading
      }}
    >
      {children}
    </PayrollContext.Provider>
  );
}
export const usePayrollContext = () => {
  return useContext(PayrollContext);
};